var _rect, _circle, _circle2, _g, _path, _circle3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledgeAssistant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    fontFamily: "Inter, Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#0e2a47"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1080,
    cy: 120,
    r: 260,
    fill: "#14375c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 720,
    r: 200,
    fill: "#123252"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 190)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: -28,
    width: 300,
    height: 380,
    rx: 18,
    fill: "#1d4570"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: -14,
    width: 300,
    height: 380,
    rx: 18,
    fill: "#25507e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 380,
    rx: 18,
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30,
    width: 170,
    height: 18,
    rx: 9,
    fill: "#0e2a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 76,
    width: 244,
    height: 10,
    rx: 5,
    fill: "#c9d2dc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 100,
    width: 220,
    height: 10,
    rx: 5,
    fill: "#c9d2dc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 124,
    width: 236,
    height: 10,
    rx: 5,
    fill: "#c9d2dc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 152,
    width: 256,
    height: 58,
    rx: 8,
    fill: "#e7ff02",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 164,
    width: 230,
    height: 10,
    rx: 5,
    fill: "#0e2a47",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 188,
    width: 190,
    height: 10,
    rx: 5,
    fill: "#0e2a47",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 232,
    width: 244,
    height: 10,
    rx: 5,
    fill: "#c9d2dc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 256,
    width: 200,
    height: 10,
    rx: 5,
    fill: "#c9d2dc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 280,
    width: 232,
    height: 10,
    rx: 5,
    fill: "#c9d2dc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 304,
    width: 160,
    height: 10,
    rx: 5,
    fill: "#c9d2dc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420 370 C 500 370, 520 330, 600 330",
    stroke: "#e7ff02",
    strokeWidth: 4,
    fill: "none",
    strokeDasharray: "10 10"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 370,
    r: 8,
    fill: "#e7ff02"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 24,
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 64,
    rx: 24,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 40,
    width: 500,
    height: 24,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 32,
    r: 14,
    fill: "#0e2a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 25,
    width: 150,
    height: 14,
    rx: 7,
    fill: "#0e2a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 96,
    width: 282,
    height: 76,
    rx: 18,
    fill: "#0e2a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 118,
    width: 230,
    height: 10,
    rx: 5,
    fill: "#ffffff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 142,
    width: 170,
    height: 10,
    rx: 5,
    fill: "#ffffff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 196,
    width: 340,
    height: 150,
    rx: 18,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 220,
    width: 290,
    height: 10,
    rx: 5,
    fill: "#5b6b7c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 244,
    width: 270,
    height: 10,
    rx: 5,
    fill: "#5b6b7c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 268,
    width: 230,
    height: 10,
    rx: 5,
    fill: "#5b6b7c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 300,
    width: 150,
    height: 28,
    rx: 14,
    fill: "#e7ff02"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 310,
    width: 118,
    height: 8,
    rx: 4,
    fill: "#0e2a47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 420,
    width: 444,
    height: 52,
    rx: 26,
    fill: "#ffffff",
    stroke: "#c9d2dc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 441,
    width: 200,
    height: 10,
    rx: 5,
    fill: "#c9d2dc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 446,
    r: 18,
    fill: "#0e2a47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 446 h14 m-6 -6 l6 6 l-6 6",
    stroke: "#e7ff02",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeAssistant);
export default __webpack_public_path__ + "static/media/knowledge-assistant.23365b5a50c2234a0cb975c8272ba2fb.svg";
export { ForwardRef as ReactComponent };